module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-12.bcbc7ca2.png";